<template>

    <div class="homeLayout" style="height:100vh">

        <div  v-bind:class="{home: isHome, 'bg-wrapper': true}">
        <div class="blueish-bg" id="bigz"></div>
        <!--        <div class="pink-bg"></div>
        <div class="yellow-bg"></div>
        -->

        </div>
        <div v-if="isHome" class="row home-nav">
            <div id="nav-links" class="col m7 nav-links">
                <!-- <a href="#pricing">pricing</a>
                <a href="#features">features</a>
                <a href="#demo">demo</a>
                <a href="#about">about</a> -->
            </div>
            <div class="col m7">
                
<!--
                <form @submit.prevent="login">
                    <div class="row login">
                        <input id="inputUsername" type="text" class="col s5" placeholder="email" v-model="username" required>
                        <div class="col s5">
                        <input id="inputPassword" type="password" class="" placeholder="password" v-model="pass" required>
                        <router-link class="forgot-password" to="/reset_password">forgot password</router-link>

                        </div>
                        <button class="btn blue col s2 log-in-btn">log in</button>
                    </div>

                </form>
                <div class="alert alert-danger text-red right-align" v-if="error">
                    <p v-if="error" class="error">{{ error.message }}</p>
                </div>
                -->
            </div>
        </div>

        <div v-if="bg_icon != 'none'" class="" >

            <div id="left-card" class="col m6 valign-wrapper left-card">
                <div class="bgX">
                    <div class="bg-icon-wrapper">
                        <div v-if="bg_icon == 'lock'"><i class='material-icons bg-icon'>lock_outline</i></div>
                        <div v-if="bg_icon == 'email'"><i class='material-icons bg-icon'>email</i></div>
                       <!-- <div v-if="bg_icon == 'fyiio'"><img class='bg-logo' src="./../../assets/bg-logo.png" /></div> -->
                    </div>


                </div>
                <!--
                <ul v-if="isHome" class='home-icon-list'>
                    <li><img class='home-icon' src="./../../assets/satisfaction.png" /> <span>increase product adoption</span></li>
                    <li><img class='home-icon' src="./../../assets/support.png" /> <span>decrease support costs</span></li>
                    <li><img class='home-icon' src="./../../assets/adoption.png" /> <span>improve customer satisfaction</span></li>
                </ul>
                -->
            </div>
            
            <div id="right-card" class='col s12 m6 right-card'>
                <!--
                <a href="http://www.fyi.io">
                  <img class='logo' src="./../../assets/fyiio-logo.svg" />
                </a>
                -->
                <slot></slot>

                
            </div>
            
        </div>
        <div v-if="bg_icon == 'none'" class="main-card card horizontal row" >


            <div id="" class='col m12 right-card'>
                <slot></slot>
            </div>
        </div>
                    
       

    </div>
</template>

<script>
export default {
    data () {
        return {
        username: '',
        email: '',
        pass: '',
        error: null
        }
    },
    props: ['isHome', 'bg_icon'],
    mounted() {
        document.body.classList.remove('has-sidebar')
        M.AutoInit();
        M.updateTextFields();
        
        document.addEventListener('DOMContentLoaded', function() {
            var elems = document.getElementById('seeTheDemo');
            var instances = M.Modal.init(elems, {
                onOpenStart: function() {
                    document.getElementById("demoModalTutorial").innerHTML = '<iframe src="https://dashboard.fyiio.com/viewer/51b0c7b3-85a7-44ad-884a-98c398f5d70b" width="100%" height="800" frameborder="0" allowfullscreen="allowfullscreen" />';                    },
                onCloseStart: function() {
                    document.getElementById("demoModalTutorial").innerHTML = '';
                }
            });

            console.log("DOM content loaded")
            var elems = document.getElementById('howItWorks');
            var instances = M.Modal.init(elems, {
                onOpenStart: function() {
                    console.log("adding how it works")
                    document.getElementById("worksModalTutorial").innerHTML = '<iframe src="https://dashboard.fyiio.com/viewer/5616f205-cd99-420a-931f-c2660e59d204" width="100%" height="800" frameborder="0" allowfullscreen="allowfullscreen"><iframe>';                    },
                onCloseStart: function() {
                    document.getElementById("worksModalTutorial").innerHTML = '';
                }
            });
        });
    },
    methods: {

        login () {
            this.$cognitoAuth.signin(this.username, this.pass, (err, result) => {
                if (err) {
                this.error = err
                    if (err.statusCode == 200) {
                        return this.$router.replace({path: '/invitation', query: {temp: this.pass, email: this.username}})
                    }
                    console.error(err)
                } else {
                    this.$router.replace(this.$route.query.redirect || '/tutorials')
                }
            })
        },

    }

}
</script>

<style scoped>
body {
    height: 100vh;
    }


    @media screen and ( max-height: 840px ) {.bg-wrapper.home{min-height:875px}}
    

/*
@media screen and ( min-height: 700px ) {.bg-wrapper{min-height:1720px}} 

@media screen and ( min-height: 1000px ) { .bg-wrapper{min-height:2200px}}


@media screen and ( min-height: 1400px ) { .bg-wrapper{min-height:1420px}}
*/

.fiedler{
  background:white;border-bottom: 0px solid orange !important;
  -webkit-box-shadow: 0 0px 0 0 orange !important;
  -moz-box-shadow: 0 0px 0 0 orange !important;
  box-shadow: 0 0px 0 0 orange !important;
}
    .bg-wrapper {
        
        overflow: hidden;
        position: absolute;
        max-width: 100%;
        top: 0;
        left: 0px;
        width: 100%;
        min-height:100%;
        z-index: -1;
    }
    .bg-wrapper.home {
        background-color:#27282A;
       
       
    }
    .blurb h3 {
        font-size: 20px;
        border-bottom: 1px solid;
        height: 75px;
    }
    .blurb i {
        padding: 10px;
        margin-right: 10px;
        border-right: 1px solid;
        height: 100%;
    }
    .blurb p {
        padding: 20px;
        text-align: center;
        padding-top: 0;
    }

    .blurb {
        border-top-right-radius: 50px;
        border-bottom-left-radius: 50px;
        min-height: 225px;
    }
    .marketing .card-title {
        font-size: 33px;
        color: #58595b;
        font-weight: 400!important;
    }
    .marketing p {
        padding-top: 10px;
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;

    }
    .marketing i {
        font-size: 50px;
        color: #939598;
    }
    .marketing .card {
        margin: 0 auto;
        margin-top: 100px;
        padding: 0;

    }
    .blurb.card {
        margin-top: 0;
    }
    .blurb h3 {
        font-weight: 400;
        height: 50px;
        color: #58595b;
    }
    .blurb {
        min-height: 147px;
    }
    .card {
        
        max-width: 1290px;
        border-radius: 10px;
    }
    .blurb p {
        font-size: 14px;
    }
    .blurb i {
        font-size: 24px;
    }
    .card .btn {
        margin-bottom: 4px;
    }
    #imac {
        height: 350px;
        overflow:hidden;
    }
    .imac {
        text-align:right;
        max-width: 80%;
    }
    .imac img {
        max-width: 90%;
        max-height: 100%;
        overflow: hidden;
    }
    #laptop, #imac {
        padding-right: 0;
    }

    .marketing .card-content {
        padding: 0;
    }
    .marketing .card-text {
        padding: 24px;
    }
    .error {
        color: red;
    }
    h2 {
        color: #58595B;
        font-family: Roboto;
        font-size: 36px;
        font-weight: 500;
        /* line-height: 42px; */
    }
    .homeLayout {
        
        padding-left: 0em;
        padding-right: 0em;
        min-width: 390px;
        width:100%;
        
    }
    .login {
        padding-top: 10px;
    }
    .login .btn {
        margin-top: 5px;
        float: right;
    }
    .main-card div, .main-card p, .main-card .row {
        z-index: 1;
    }
    .home-nav {
        margin-bottom: -5em;
        max-width: 1290px;
    }
    #nav-links {
        padding-top: 18px;
    }
    #nav-links a {
        color: white;
        padding: 1em;
        font-size: 18px;
    }
    #nav-links a:hover {
        font-weight: bold;
    }
    .main-card {
        margin: 0 auto;
        margin-top: 10em;
        border-radius: 15px;
        overflow: hidden;
        max-width: 1290px;
    }
    #left-card {
        color: white;
        padding: 3em;
        border-radius: 15px;
        overflow: hidden;
        font-size: 24px;
    }
    #left-card ul i {
        padding-right: 15px;
        margin-top: 15px;
        top: 4px;
        position: relative;
    }
    #left-card ul {
        z-index: 10;
    }
    #left-card li {
        margin-bottom: 15px;
    }
    .bg-icon {
        position: absolute;
        left: 0px;
        top: -150px;
        font-size: 850px;
        color: white;
        opacity: 0.2;
        transform: rotate(-60deg);
    }
    .bg-logo {
        opacity: 0.2;
        transform: rotate(-60deg);
    }
    .bg-icon-wrapper {
        transform: skewX(-15deg);
    }
    #left-card .bg {
        background-color: #58595b;
        width: 50%;
        height: 100%;
        z-index: -10;
        position: absolute;
        left: -100px;
        transform: skewX(15deg);
        border-left: 100px solid #58595b;
    }
    
    #right-card {

        padding: 3em;
    }
    /*        background-image: url('./../../assets/1.png');*/
@media only screen and (max-width: 600px) {
    
}
@media only screen and (min-width: 1000px) {
       .blueish-bg {
                background-image: url('./../../assets/maker2.jpeg');
                background-repeat: no-repeat;
                background-size: 100% auto;
                background-position: left top;
                background-attachment: fixed;
                background-position-x: -200px;
                
                }
        .blue-bg {
                background-image: url('./../../assets/maker.png');
                background-repeat: no-repeat;
                background-size: 30% auto;
                background-position: left top;
                background-attachment: fixed;
                background-position-x: 0px;
                }
                
        .babyblue-bg {
                background-image: url('./../../assets/maker3_milkyway.jpeg');
                background-repeat: no-repeat;
                background-size: 100% auto;
                background-position: left top;
                background-attachment: fixed;
                background-position-x: -300px;
                }
                
        .mountain-bg {
                background-image: url('./../../assets/maker_mountain.jpeg');
                background-repeat: no-repeat;
                background-size: cover;
                background-position: left top;
                background-attachment: fixed;
                background-position-x: -300px;
                }
        .fish-bg {
                background-image: url('./../../assets/maker_fish.jpeg');
                background-repeat: no-repeat;
                background-size: 100% auto;
                background-position: left top;
                background-attachment: fixed;
                background-position-x: -950px;
                }
    }

.blueish-bg {
        
        background-repeat: no-repeat;
        background-size: cover;
        z-index: -1;
        position: absolute;
        width: 33%;
        height: 100%;
        top: 0;
        left: 0;
        background-position-x: -300px;
    }

    .blue-bg {
        
        background-size: contain;
        background-repeat: repeat-y; 
        z-index: -1; 
        position: absolute;
        width: 33%;
        height: 100%;
        top: 0;
        left: 0;
    }
    
    .babyblue-bg {
        
        background-size: cover;
        background-repeat: repeat-y;
        z-index: -1;
        position: absolute;
        width: 33%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .fish-bg {
        
        background-size: cover;
        background-repeat: repeat-y;
        z-index: -1;
        position: absolute;
        width: 33%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .mountain-bg {
        
        background-size: cover;
        background-repeat: repeat-y;
        z-index: -1;
        position: absolute;
        width: 33%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .pink-bg {
        position: absolute;
        width: 700px;
        height: 1000px;
        top: 1000px;
        right: 0;
        background-image: url('./../../assets/2.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right;
        z-index: -10;
        overflow: hidden;
    }
    .yellow-bg {
        position: absolute;
        width: 1000px;
        height: 700px;
        top: 2000px;
        left: 0;
        background-image: url('./../../assets/green-bg.png');
        background-size: contain;
        background-repeat: no-repeat;
        z-index: -10;
    }
    .logo {
        width: 210px;
    }
    .footer {
        margin-top: 12em;
        color: #58585a;
        width: 100%;
        position: absolute;
        left:0;
        background-color: #fff;
        padding-top: 20px;
        padding-bottom: 0;
    }
    .footer a {
        color: #58585a;
        padding: 1em;
    }
    .footer .row {
        width: 100%;
    }
    .footer p {
        margin: 0;
    }
    .footer-brand span {
        padding-left: 0.5em;
        font-size: 2em;
    }
    .btn {
        margin-top: 1em;
    }
    .message {
        opacity: 0.54;
        margin-top: 24px;
    }
    .forgot-password {
        color: #939598;
        font-size: 14px;

    }
.login .btn, .blue {
    background-color: #27aae1!important;
}
.btn.blue:hover {
    background-color: #00a79d!important;
}
.imac {
    padding-right: 0;
}
.iphone, .laptop {
    margin-top: 10px;
    margin-bottom: 10px;
    height: 375px;
}
.modal .modal-footer .btn, .modal .modal-footer .btn-large, .modal .modal-footer .btn-small, .modal .modal-footer .btn-flat {
    padding-top: 10px;
}
.home-icon-list span {
    margin-top: -5px;

}
.home-icon {
    width: 24px;
    height: auto;
    display: inline-block;
    position: relative;
    top: 5px;
}
.tos-links {
    margin-top: 22px;
}
.log-in-btn {
  width: 79px!important;
}
.login.btn {
    width: 79px!important;
}
.imac {
    height: 375px;
    float: right;
    text-align: right;

}
.imac .valign-wrapper {
    text-align: right;
}
.imac img {
    margin: 0 auto;
}

#seeTheDemo, #howItWorks {
    min-width: 80%;
    width: 85%;
    /* max-width: 850px; */
    min-height: 500px;
    background-color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/containers/layouts/HomeAltLayout.vue